import React, { useState } from 'react';
import { Mail, ArrowLeft } from 'lucide-react';
import { useAuthStore } from '../../stores/useAuthStore';
import { LoadingSpinner } from '../LoadingSpinner';

interface RequestPasswordResetFormProps {
  onSuccess: (email: string) => void;
  onCancel: () => void;
}

export const RequestPasswordResetForm: React.FC<RequestPasswordResetFormProps> = ({ onSuccess, onCancel }) => {
  const { requestPasswordReset, error, isValidating } = useAuthStore();
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    
    try {
      await requestPasswordReset(email);
      onSuccess(email);
    } catch (err) {
      // Error handled in store
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 animate-fade-in">
      <div className="text-center mb-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">Recuperar contraseña</h3>
        <p className="text-sm text-gray-500 mt-2">Ingresá tu email para recibir el código de recuperación.</p>
      </div>

      <div className="space-y-1">
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Correo electrónico
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Mail className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="block w-full pl-10 pr-3 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 focus:ring-2 focus:ring-sky-500 focus:border-transparent transition-colors"
            placeholder="tu@email.com"
            required
            disabled={isValidating}
          />
        </div>
      </div>

      {error && (
        <div className="text-red-500 text-sm text-center bg-red-50 dark:bg-red-900/20 p-2 rounded-lg">
          {error}
        </div>
      )}

      <div className="pt-2 flex flex-col gap-3">
        <button
          type="submit"
          disabled={isValidating}
          className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
        >
          {isValidating ? <LoadingSpinner size="sm" color="white" /> : 'Enviar código'}
        </button>

        <button
          type="button"
          onClick={onCancel}
          disabled={isValidating}
          className="w-full flex justify-center items-center py-2 px-4 text-sm font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Volver al inicio de sesión
        </button>
      </div>
    </form>
  );
};
